// extracted by mini-css-extract-plugin
export default {"image":"image-styles_image__dN05O","close":"image-styles_close__NSYKy"};